<template>
  <div class="flex h-full flex-col overflow-hidden bg-white">
    <div class="flex items-center justify-between px-8 py-4" style="background-color: #E2E8F0;">
      <div class="h-full flex items-center text-base font-medium uppercase text-black">
        View Detail
      </div>
      <div class="text-slate-500 transition hover:text-slate-700 cursor-pointer" @click="$emit('close')">
        <Icon icon-name="CloseIcon" />
      </div>
    </div>

    <div class="flex-1 space-y-6 bg-white px-8 py-6 mt-4">
      <div class="relative border border-slate-200 bg-white p-6 rounded-md">
        <div
          class="absolute badge-dot inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
          <span>{{ integration.name }}</span>
        </div>
        <div v-for="detail in integration.details" :key="detail.label" class="flex items-center mb-2">
          <div class="flex items-center gap-3 text-sm text-slate-600 ">
            <div class="inline-flex h-8 w-8 items-center justify-center rounded bg-slate-100 text-slate-500">
              <Icon v-if="detail.icon" :icon-name="detail.icon" />
            </div>
            <div class="font-medium text-slate-700 detail-row">{{ detail.label }}</div>
          </div>
          <div class="flex items-center gap-3 text-sm font-semibold text-slate-700">
            :
            <span v-if="detail.variant === 'status'" :class="[
              'inline-flex items-center rounded-sm px-3 py-2 text-xs font-semibold',
              detail.statusClass || 'bg-green-100 text-green-600'
            ]">
              <span :class="[
                'mr-2 inline-block h-2 w-2 rounded-full',
                detail.dotClass || 'bg-green-500'
              ]"></span>
              {{ detail.value }}
            </span>
            <span v-else class="text-slate-700">{{ detail.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../core/Icon.vue";

export default {
  name: "IntegrationDetail",
  components: {
    Icon
  },
  props: {
    integration: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.badge-dot {
  top: -16px;
  border-radius: 3px;
}

.detail-row {
  width: 150px !important;
}
</style>
